import { lazy, Suspense } from "react";
import type { RouteObject } from "react-router-dom";
import Layout from "@/components/feature/Layout";
import Home from "@/pages/home/page";
import Admission from "@/pages/admission/page";
import Classes from "@/pages/classes/page";
import Schedule from "@/pages/schedule/page";
import About from "@/pages/about/page";
import Consult from "@/pages/consult/page";
import NotFound from "@/pages/NotFound";

// 관리자 화면은 방문자 번들에 포함되지 않도록 별도 파일로 분리 로드
const Admin = lazy(() => import("@/pages/admin/page"));

const routes: RouteObject[] = [
  {
    path: "/admin/:section?",
    element: (
      <Suspense fallback={null}>
        <Admin />
      </Suspense>
    ),
  },
  {
    path: "/",
    element: <Layout />,
    children: [
      {
        index: true,
        element: <Home />,
      },
      {
        path: "admission",
        element: <Admission />,
      },
      {
        path: "classes",
        element: <Classes />,
      },
      {
        path: "schedule",
        element: <Schedule />,
      },
      {
        path: "about",
        element: <About />,
      },
      {
        path: "consult",
        element: <Consult />,
      },
    ],
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;